var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDontknow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3549 0 0 14.3549 0 32C0 49.6451 14.3549 64 32 64C49.6451 64 64 49.6451 64 32C64 14.3549 49.6451 0 32 0ZM42.9091 16C45.7207 16 48 18.2793 48 21.0909C48 23.9025 45.7207 26.1818 42.9091 26.1818C40.0975 26.1818 37.8182 23.9025 37.8182 21.0909C37.8182 18.2793 40.0975 16 42.9091 16ZM19.6364 16C22.448 16 24.7273 18.2793 24.7273 21.0909C24.7273 23.9025 22.448 26.1818 19.6364 26.1818C16.8247 26.1818 14.5455 23.9025 14.5455 21.0909C14.5455 18.2793 16.8247 16 19.6364 16ZM48 45.0909H16C15.1956 45.0909 14.5455 44.4393 14.5455 43.6364C14.5455 42.8335 15.1956 42.1818 16 42.1818H48C48.8044 42.1818 49.4545 42.8335 49.4545 43.6364C49.4545 44.4393 48.8044 45.0909 48 45.0909Z",
    fill: "#F2E618"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontknow);
export default __webpack_public_path__ + "static/media/dontknow.5b8b834a6e7233fbefccf4ead2920b7b.svg";
export { ForwardRef as ReactComponent };